import React, {useCallback, useRef, useState} from 'react'
import {message} from 'antd'
import {SDrawerOrModal, SLowcodeList, STriggerModal} from 'shj-components'
import config from './config'
import {httpOrgList} from "@/services/homeService.ts";

import { dcpHiShjAccount, dcpHiShjAccountSearchList} from '@/services/kuAccount'
import {apiData2Table} from "@/utils/data.ts";
import {fileConfirm} from "@/utils/common.ts";

const useRecord = props => {
  const {record, open, reload, onClose, companyList} = props
  const listRef = useRef<any>()
  const [exportLoading, setExportLoading] = useState<boolean>(false)

  const fetchList = (values: { current: number; pageSize: number; query: Record<string, any> }) => {
    return new Promise(async (resolve, reject) => {
      try {
        const {current, pageSize, query} = values
        dcpHiShjAccountSearchList(current, pageSize, query).then(data => resolve(data))
      } catch (e) {
        reject({success: false})
      }
    })
  }

  // 获取下拉
  const getSelection = () => {
    return new Promise(resolve => {
      Promise.all([httpOrgList()]).then(resp => {
        const listObj = {
          companies: resp[0],
        }
        resolve(listObj)
      })
    })
  }
  const onExport = useCallback((record: any) => {
    const searchData_ = listRef.current.getSearch().getFieldsValue()
    setExportLoading(true)
    message.loading({content: '导出中'})
    dcpHiShjAccount(searchData_)
      .then((res: any) => {
        fileConfirm()
        if (res.status && res.status === 200) {
          message.destroy()
          setExportLoading(false)
        } else {
          message.error('下载失败')
          message.destroy()
          setExportLoading(false)
        }
      })
      .catch(() => {
        message.destroy()
        setExportLoading(false)
      })
  }, [])
  const extension = {
    request: {fetchList, getSelection},
    events: {onExport},
    status: {
      exportLoading: exportLoading,
    },
    customRender: {
      claimUser(text, record) {
        return record.claimUserName + '-' +  record.claimUser
      },
    },
  }
  return (
      <SDrawerOrModal width={1200} title={'领用记录'} open={open} onCancel={onClose} antdProps={{footer:null}}>
        <SLowcodeList searchMode={'group'} config={config} ref={listRef} {...extension} rowKey={'id'}/>
      </SDrawerOrModal>
  )
}

export default useRecord
